<mat-form-field [class]="getPanelClasses()" appearance="outline" >
  <mat-label>{{ schema.label }}</mat-label>
  <input
    matInput
    [min]="schema.min"
    [max]="schema.max"
    [required]="schema.required"
    [matDatepicker]="dp"
    placeholder="{{ schema.placeholder }}"
    [formControl]="this.date"
    (keyup)="keyUp($event)"
    libMask="00/00/0000"
    (dateChange)="chosenDayHandler($event, dp)"
  />
  <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
  <mat-datepicker #dp startView="month"></mat-datepicker>
</mat-form-field>
